import { setRecoil } from "recoil-nexus";
import participantsState from "../../atoms/participants";
import { socket } from "../index";

interface ListenReceiveUsersPayload {
  roomId: string;
  users: ({ id: string, createAt: number })[];
}

const listenReceiveUsers = () => {
  socket?.on('RECEIVE_USERS', (payload: ListenReceiveUsersPayload) => {
    setRecoil(participantsState, {
      roomId: payload.roomId,
      users: payload.users.map(user => user.id),
    });
  });
}

export default listenReceiveUsers;